import actionTypes from '../constants/action-types';

const addCustomGradient = (gradient) => ({
  type: actionTypes.ADD_CUSTOM_GRADIENT,
  payload: {
    gradient,
  },
});

export default addCustomGradient;
